<div class="flex min-h-screen flex-col">
  <brand-header></brand-header>
  <div class="flex flex-1 items-center">
    <div class="max-w-3xl text-center font-bold mx-auto text-balance">
      <p>Oops! We had a technical error. Our team is working to fix it right now.</p>
      <p>In the meantime, please call (800) 670-1839 to ensure your order processed correctly.</p>
      <p>We apologize for any inconvenience. Thank you for joining the Dr. Marty Pets family!</p>
    </div>
  </div>
  <brand-footer></brand-footer>
</div>
